import mutations from './systemTransitionMutation';
import actions from './systemTransitionAction';
import getters from './systemTransitionGetter';

const state = {
  divisionInfo: [],
  gridData: {},
  statusList: [],
  oriGridData: [],
  iamUserData: [],
  adminYn: false,
  searchParam: {
    transOrder: '',
    domestic: '',
    gbmgroup: '',
    divisionCd: '',
    cspCd: [],
    projectNm: '',
    plId: '',
    projectCreateYn: '',
    accountId: '',
    cutOverCompleteYn: '',
    accountDeletedYn: '',
    searchType: 'console',
    adminYn: false,
    pageIndex: 1,
    pageSize: 10,
    excelYn: 'N',
    exceptionType: '',
    routeInit: false,
    tab: '',
  },
};


export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/systemTransition/systemTransitionStore.js